import React from 'react'
import { connect } from 'react-redux'
import firebase from 'firebase/app'
import { Segment, Button, Card, Header } from 'semantic-ui-react'
import { map, size } from 'lodash'
import styled from 'styled-components'

import MenuActions from '../../../../reducers/menuReducer'
import AppCustomizationActions from '../../../../reducers/appCustomizationReducer'

import CategoryCard from './card'
import CategoryForm from './form'

const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between
`

const styles = {
  cardGroup: {
    display: 'inline-flex',
    flexWrap: 'nowrap',
    width: 'calc(100vw - 330px)',
    overflowX: 'scroll',
    marginTop: 0,
  },
  header: {
    display: 'inline-block',
    marginBottom: 0,
  }
}

class EntryScreen extends React.Component {
  state = {
    formVisible: false,
    formData: null,
  }

  componentDidMount() {
    const { getCustomization, getMenus } = this.props

    getMenus()
    getCustomization({
      screen: 'entry',
      resource: 'categories',
      orderBy: ['created_at', 'desc']
    })
  }

  onDeleteClick = async ({ id }) => {
    try {
      const { removeSingleCustomization } = this.props

      const collectionRef = firebase.firestore().collection('app_customization')

      await collectionRef
        .doc('entry')
        .collection('categories')
        .doc(id)
        .delete()

      await this.removeFromServiceArrangement(id)

      removeSingleCustomization({ screen: 'entry', resource: 'categories', id })
    } catch (error) {
      alert('Failed to delete display category')
    }
  }

  removeFromServiceArrangement = async id => {
    const { removeSingleCustomization } = this.props

    try {
      const collectionRef = firebase.firestore().collection('app_customization')

      await collectionRef
        .doc('entry')
        .collection('services')
        .doc(id)
        .delete()

      removeSingleCustomization({ screen: 'entry', resource: 'services', id })
    } catch (error) {
      //
    }
  }

  onEditClick = category => {
    this.setState({ formVisible: true, formData: category })
  }

  renderCardList = () => {
    const { displayCategories, categories } = this.props

    return (
      <Card.Group style={styles.cardGroup} className="hide-scrollbar">
        {map(displayCategories, (category, key) => (
          <CategoryCard
            key={key}
            onEditClick={this.onEditClick}
            onDeleteClick={this.onDeleteClick}
            category={{ ...category, categoryName: categories[key] && categories[key].name }}
          />
        ))}
        <div style={{ minWidth: 1 }} />
      </Card.Group>
    )
  }

  renderNoResult = () => <div style={{ marginTop: 14 }}>No results</div>

  render() {
    const { displayCategories, categories, loading } = this.props
    const { formVisible, formData } = this.state

    return (
      <Segment color="black" loading={loading}>
        <HeaderWrapper>
          <Header content="Display Categories" size="large" style={styles.header} />
          <Button icon="add" color="black" floated="right" onClick={() => this.setState({ formVisible: true })} />
        </HeaderWrapper>

        {size(displayCategories) > 0 ? this.renderCardList() : this.renderNoResult()}

        {formVisible && (
          <CategoryForm
            visible={formVisible}
            category={formData}
            categories={categories}
            onClose={() => this.setState({ formVisible: false, formData: null })}
          />
        )}

      </Segment>
    )
  }
}

const getCategoriesFromMenu = menus => {
  const categories = {}

  Object.values(menus).forEach(menu => {
    const categoryKeys = Object.keys(menu.categories || {})

    categoryKeys.forEach(categoryKey => {
      const { name, image } = menu.categories[categoryKey] || {}

      categories[categoryKey] = { name, image }
    })
  })

  return categories
}

const mapState = ({ appCustomization: { entry }, menus }) => ({
  categories: getCategoriesFromMenu(menus.data),
  services: entry.services.data,
  servicesLoaded: entry.services.loaded,

  displayCategories: entry.categories.data,
  loading: menus.loading || entry.categories.loading,
})

const mapDispatch = {
  getMenus: MenuActions.fetchMenusRequest,
  getCustomization: AppCustomizationActions.getCustomization,


  removeSingleCustomization: AppCustomizationActions.removeSingleCustomization,
}

export default connect(mapState, mapDispatch)(EntryScreen)



// WEBPACK FOOTER //
// ./src/containers/appCustomization/components/EntryCategories/index.js